#import "../fragments/lead-distribution-automation.graphql"

mutation CreateLeadDistributionAutomation(
    $leadDistributionAutomation: CreateLeadDistributionAutomationInputFieldInput!
) {
    createLeadDistributionAutomation(
        input: {leadDistributionAutomation: $leadDistributionAutomation}
    ) {
        leadDistributionAutomation {
            ...LeadDistributionAutomation
        }
    }
}
